import { SideNavLink } from "@ui/molecules/SideNavLink/SideNavLink";
import * as React from "react";
import styles from "./SideNavigation.module.scss";
import {
	TaskListLtrFilled,
	//	HomeRegular,
	CalendarAddRegular,
	DocumentBulletListRegular,
	// ChartMultipleRegular,
	FolderOpenRegular,
} from "@fluentui/react-icons";
import { usePortalConfig } from "@/hooks/PortalConfig";
export interface ISideNavigationProps {}

export function SideNavigation(props: ISideNavigationProps) {
	const pc = usePortalConfig();
	return (
		<div className={styles.sideNavigation}>
			{/* <SideNavLink label="Dashboard" icon={HomeRegular} path="dashboard"></SideNavLink> */}
			<SideNavLink label="Work In Progress" icon={TaskListLtrFilled} path="wip"></SideNavLink>
			<SideNavLink label="Manage Requests" icon={CalendarAddRegular} path="ros" />

			{/* <SideNavLink label="Reports" icon={ChartMultipleRegular} path="reports" /> */}
			{!pc.data?.preview && (
				<>
					{/* <SideNavLink label="Archived" icon={FolderOpenRegular} path="ros/archived" /> */}
					<SideNavLink label="Invoiced" icon={DocumentBulletListRegular} path="invoiced" />
				</>
			)}
		</div>
	);
}
